import React, { FunctionComponent, SVGProps } from 'react'

export const IconArrow: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#858591"
      {...props}
    >
      <path
        d="M1 13L7 7L0.999999 1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
